import { RaRecord, useRecordContext } from 'ra-core'

export const useKRecordContext = <T extends RaRecord>() => {
  return useRecordContext<T>() as T | undefined
}
